import React from "react";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import { findArray } from 'helpers/utils'
import Card from 'react-bootstrap/Card';
import SportCode from 'components/common/SportCode';
import Label from "components/general/Label";

export function CompetitorBlock(competitor) {
    let colour = competitor?.resultItem === undefined ? competitor?.cp_start_order : findArray(competitor?.resultItem?.eventUnitEntries, { eue_code: ['BIB_COLOUR'] }).eue_value;
    let colorClass = (colour === "WHITE") ? ('border w-15 px-1 text-end bg-' + colour).toLowerCase() : ('w-15 px-1 text-end bg-' + colour).toLowerCase()
    const isTeam = competitor?.participant?.__typename === 'Team'
    return (
        <div className="d-flex">
            <div className={colorClass}>
                {competitor?.resultItem?.bib}
            </div>
            <div className='score-noc d-none d-md-block w-20'>
                <Noc {...competitor?.participant?.organisation} showImgAlt={isTeam ? false : true} />
            </div>
            <div className='score-name w-60'>
                <Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} />
            </div>
        </div>
    )
}

export function Header({ data, bracket, phase }) {
    return (
        <Card.Header>
            <div className='score-header'>
                <span>{data?.eventUnit?.shortDescription}</span>
            </div>
        </Card.Header>
    )
}

export function CompetitorBlockNoData(competitor) {
    let colour = competitor.cp_start_order
    let colorClass = (colour === "WHITE") ? ('w-15 border px-1 text-end bg-' + colour).toLowerCase() : ('w-15 px-1 text-end bg-' + colour).toLowerCase()

    return (
        <div className='d-flex'>
            <div className={colorClass}>&nbsp;</div>
            {competitor.cp_code !== 'TBD' && <div className="w-90 ps-1"><SportCode code={competitor.cp_code} discipline={'SRF'} entity="@CompetitorPlace" notFound={<>&nbsp;</>} /></div>}
        </div>
    )
}

export function CompetitorHeader() {
    const title = Label({ data: "HeaderJersey", sport: "SRF", noHtml: true })
    return (
        <div className="d-flex">
            <div className="d-flex w-70">
                <div className="text-end w-15 px-1 fw-bold"><abbr title={title}><Label data="HeaderJerseyShort2" /></abbr></div>
                <div className="w-85 text-start px-1 fw-bold"><Label data="HeaderName" /></div>
            </div>
            <div className="w-30 text-end px-1 fw-bold"><Label data="HeaderPoints" /></div>
        </div>
    )
}